export default function SectionHeadingAlt({ children }) {
  return (
    <div className='text-center xl:text-left pb-3 xl:pb-8'>
      <h2 className='text-srt-3xl font-intel-one-display font-medium text-theme-intel-2020-e-gray-s2'>
        {children}
      </h2>
    </div>
  );
}
